module.exports = __webpack_public_path__ + "img/01-mobile.07460f71.jpg";